import { Capacitor } from '@capacitor/core';
import { GcActualizador } from '@geekcommerce/printer';

// Puente con el plugin nativo que descarga e instala el APK (plugins/printer,
// GcActualizadorPlugin). Solo existe en la app de Android: en iOS actualiza la
// App Store y en el navegador la página se recarga sola.
export const puedeActualizarse = () =>
  Capacitor.getPlatform() === 'android' && Capacitor.isPluginAvailable('GcActualizador');

export const infoApp = () => GcActualizador.info();

/** Baja el APK y verifica su huella. `alAvanzar(0..1)` mientras descarga. */
export async function descargarApk(version, alAvanzar) {
  const oyente = await GcActualizador.addListener('progreso', ({ recibidos, total }) => {
    alAvanzar?.(total > 0 ? Math.min(1, recibidos / total) : 0);
  });
  try {
    await GcActualizador.descargar({ url: version.url, sha256: version.sha256, versionCode: version.versionCode });
  } finally {
    oyente.remove();
  }
}

/** Abre el instalador de Android. Rechaza con code 'PERMISO' si falta el permiso. */
export const instalarApk = (versionCode) => GcActualizador.instalar({ versionCode });
